import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const objections = ['This is not a random collection of wrestling drills copied from the internet.', 'This is not a theory-heavy wrestling book that you have to rewrite before it becomes useful on the mat.', 'This is not a single-technique program that leaves the rest of athlete development uncovered.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-mist relative overflow-hidden border-y border-mist-dark" data-id="element-242" data-mp="z1mrs9lfw9qf">
      <div className="max-w-4xl mx-auto text-center" data-id="element-243" data-mp="u3urosan5hb5">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-244" data-mp="182kmg19zn4wc">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/15 text-gold-dark mb-5" data-id="element-245" data-mp="2jg6mwilassx6">
            <span className="text-2xl" data-id="element-246" data-mp="2ffcwnikdv214">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-navy" data-id="element-247" data-mp="2bwi9svmr3y6o">
            The Complete Professional Coaching System
          </h2>
          <h3 className="text-xl font-bold text-gold-solid mb-3" data-id="element-248" data-mp="2gwwi8es9la58">
            Wrestling Coach Ready — 6 Complete Volumes of Ready-to-Coach Sessions
          </h3>
          <p className="text-base md:text-lg text-slate mb-10" data-id="element-249" data-mp="2pu6y6dg11ngh">
            150 ready-to-coach sessions · 5 professional bonus guides · Beginner to advanced ·
            Ready to use today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-250" data-mp="1x72qu1tgox1j">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white p-6 rounded-2xl border border-mist-dark shadow-sm" data-id="element-251" data-mp="224uq5gwfrlfr">
            {objections.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-252" data-mp="2hqz0142uyn9i">
                <X className="text-alert shrink-0 mt-1" size={18} data-id="element-253" data-mp="2how3e1779vvt" />
                <p className="text-slate text-sm" data-id="element-254" data-mp="2crmhgvj0s2cq">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-navy p-6 rounded-2xl border border-gold/40 relative overflow-hidden" data-id="element-255" data-mp="2qln6uyo30d0f">
            <div className="flex items-start gap-3 relative z-10" data-id="element-256" data-mp="27st2szrzy5az">
              <Check className="text-gold-light shrink-0 mt-1" size={20} data-id="element-257" data-mp="27qyfxfx60349" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-258" data-mp="22t6rivvqaz4t">
                This is a complete professional coaching library designed to help you walk
                into every practice prepared, organized and confident about what to teach
                next.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}